import {ListTitleTextMrGreenBox} from "./list-title-text.mrgreen.box";

export const ListTitleTextMrgreenCisBox = ListTitleTextMrGreenBox;